<template>
  <div class="page">
    <div ref="h_top">
      <van-nav-bar title="新增" left-text="返回" right-text="新增" @click-right="addSuggest" left-arrow @click-left="back" class="bg-gradual-blue"></van-nav-bar>
    </div>
    <div ref="h_cont" style="margin:0 5px;overflow-y: auto;">
      <van-form @submit="onSubmit">
		<van-field :rules="[{ required: true, message: '请选择类型' }]" readonly clickable name="picker" :value="temp.rtypeName" label="类型" placeholder="点击选择类型" @click="showPicker = true"/>
		<van-popup v-model="showPicker" position="bottom">
		  <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
		</van-popup>
		
		<van-field :rules="[{ required: true, message: '请选输入内容' }]" v-model="temp.content" rows="2" autosize label="内容" type="textarea" maxlength="100" placeholder="请输入内容" show-word-limit />
		  
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
	
	<van-popup v-model="addPopup" closeable position="center" :style="{ height: '80%' }" />
	
	
  </div>
  
  
</template>

<script>
  import { loadData , showToast , hideToast } from '@/utils/common'
  import { Dialog  } from 'vant';

  export default {
    components: { Dialog },
    data() {
      return {
        loading:false,
        finished:false,
        list:[],
        start:1,
        limit:10,
        isQuery:false,
		skuShow:false,
		temp:{},
		showPicker:false,
		columns:['咨询','建议'],
		addPopup:false
      }
    },
    mounted() {
      //this.initScreenH();
    },
    methods: {
      initScreenH(){
        let fh = document.documentElement.clientHeight;
        let th = this.$refs.h_top.offsetHeight;
        this.$refs.h_cont.style.height = (fh - th)+'px';
      },
	  onConfirm(e,idx){
		 this.temp.rtype = idx + 1;
		 this.temp.rtypeName = e;
		 this.showPicker = false;
	  },
	  onSubmit(){
		  this.temp.userId = sessionStorage.getItem('login_userid');
		  showToast();
		  loadData('/appMy/addSuggest',paramsJson).then(response => {

		    hideToast();
		  }).catch(() => {
		    this.isQuery = false;
		    hideToast();
		    //this.listLoading = false
		  })
	  },
	  
      initQuery(){
        this.list = [];
        this.start = 1;
        this.finished = false;
        this.loadList();
      },
      back() {
        history.back();
      },
      loadList(){
        if(this.isQuery){
          return;
        }
        this.isQuery = true;
        var paramsJson = {
          "userId": sessionStorage.getItem('login_userid'),
          "page": this.start,
          "limit": this.limit
        }
		showToast();
        loadData('/appMy/querySuggestPage',paramsJson).then(response => {
          if(response && response.code == 0){
            let tList = response.data.list;
            for(let i = 0;i < tList.length;i++){
              this.list.push(tList[i]);
            }
            this.start = response.data.nextPage;
            this.finished = response.data.isLastPage;
            this.loading = false;
          }
		  this.isQuery = false;
		  hideToast();
        }).catch(() => {
          this.isQuery = false;
		  hideToast();
          //this.listLoading = false
        })
      },
	  addSuggest(){
		  
	  },
      cancelSroom(row) {
        Dialog.confirm({
          message: '确认取消该预约吗？',
        }).then(() => {
          let param = {
            'id': row.id
          };
          loadData('/appSroom/cancel',param).then(response => {
            if(response && response.code == 0){
              row.reserveState = 5;
            }else{
              Toast(response.message);
            }
          }).catch(() => {
            //this.listLoading = false
          })
        }).catch(() => {
          //alert(2);
        });
      },
      endSRoomReserve(row){
        Dialog.confirm({
          message: '确认结束该预约吗？',
        }).then(() => {
          let param = {
            'id': row.id
          };
          loadData('/appSroom/endRecord',param).then(response => {
            if(response && response.code == 0){
              row.reserveState = 7;
            }else{
              Toast(response.message);
            }
          }).catch(() => {
            //this.listLoading = false
          })
        }).catch(() => {
          //alert(2);
        });
      },
      gotoReserveDetail(row){
        
      },
      openDoor(row){

      },
    }
  };
</script>

<style lang="less" scoped>
.logout {
  bottom: 0;
  height: 50px;
  color: #ff5f16;
}
</style>

